import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, onConsentChange, setConsent, type ConsentState } from "@/lib/consent";

export default function ConsentBanner() {
  const [state, setState] = useState<ConsentState>(getConsent);

  useEffect(() => {
    return onConsentChange(setState);
  }, []);

  if (state !== "unknown") return null;

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="fixed bottom-0 inset-x-0 z-40 border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900"
    >
      <div className="max-w-6xl mx-auto px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3 text-sm">
        <p className="flex-1 text-slate-700 dark:text-slate-300">
          We use anonymous analytics to improve the catalog. No personal data is collected.{" "}
          <Link to="/privacy" className="underline">
            Privacy policy
          </Link>
          .
        </p>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => setConsent("denied")}
            className="px-3 py-1 rounded border border-slate-300 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800"
          >
            Essentials only
          </button>
          <button
            type="button"
            onClick={() => setConsent("granted")}
            className="px-3 py-1 rounded bg-brand-500 text-white hover:bg-brand-600"
          >
            Accept analytics
          </button>
        </div>
      </div>
    </div>
  );
}
